import {
  approveCitationRequest,
  cancelCitationRequest,
  createCitationRequest,
  listCitationRequests,
  notifyCitationRequest,
} from './citationRequests';
import { listStatementReferences, updateStatementReferences } from './statementReferenceCalls';
import type { ReferenceAssistantGateway } from '../ports/referenceAssistantGateway';

/** The reference assistant's backend. Analytics are the hooks' job, not this. */
export const fetchReferenceAssistantGateway: ReferenceAssistantGateway = {
  listCitationRequests,
  createCitationRequest,
  approveCitationRequest,
  notifyCitationRequest,
  cancelCitationRequest,
  listStatementReferences,
  updateStatementReferences,
};
